type GetLegendLabelParams = {
    name: string;
    type: "horizontal" | "vertical";
    color: string;
    className?: string;
};

export const getLegendLabel: (params: GetLegendLabelParams) => string = ({ name, type, color, className = "" }) => `
  <div class="ariaStack-legend ariaStack-legend--flex ${className}">                    
    <span class="item-marker--full ${type}" style="background-color: ${color};"></span>
    <span class="legend-name-text ${type}" title="${name}">${name}</span>
  </div>
`;
